/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Tlm_1Inputs */

const en_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`response`)
};

const ar_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاستجابة`)
};

const bn_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিক্রিয়া`)
};

const de_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktion`)
};

const es_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta`)
};

const fr_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponse`)
};

const pt_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta`)
};

const zh_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应`)
};

const tr_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yanıt`)
};

const ru_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реакция`)
};

const pl_svc_retainer_tlm_1 = /** @type {(inputs: Svc_Retainer_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reakcja`)
};

/**
* | output |
* | --- |
* | "response" |
*
* @param {Svc_Retainer_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_tlm_1 = /** @type {((inputs?: Svc_Retainer_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_tlm_1(inputs)
	if (locale === "bn") return bn_svc_retainer_tlm_1(inputs)
	if (locale === "de") return de_svc_retainer_tlm_1(inputs)
	if (locale === "es") return es_svc_retainer_tlm_1(inputs)
	if (locale === "fr") return fr_svc_retainer_tlm_1(inputs)
	if (locale === "pt") return pt_svc_retainer_tlm_1(inputs)
	if (locale === "zh") return zh_svc_retainer_tlm_1(inputs)
	if (locale === "tr") return tr_svc_retainer_tlm_1(inputs)
	if (locale === "ru") return ru_svc_retainer_tlm_1(inputs)
	if (locale === "pl") return pl_svc_retainer_tlm_1(inputs)
	return en_svc_retainer_tlm_1(inputs)
});